/* Selected vehicle only. No VIN, account, checkout or customer data is stored. */
(function () {
  'use strict';
  if (window.JSSVehicle || !window.JSDieselFitment) return;
  const core = window.JSDieselFitment;
  const key = 'jss:vehicle:v1:' + (document.currentScript?.dataset.themeId || 'theme');
  const clean = values => Object.fromEntries(core.keys.map(k => [k, core.text(values?.[k]).slice(0, 120)]));
  const equal = (a, b) => core.keys.every(k => core.normal(a?.[k]) === core.normal(b?.[k]));
  function valid(raw) {
    if (!raw || raw.version !== 1 || !Number.isFinite(raw.savedAt) || raw.savedAt > Date.now() + 60000) return null;
    const values = clean(raw.values);
    if (!values.make) return null;
    return { version: 1, values, confirmedKeys: core.keys.filter(k => Array.isArray(raw.confirmedKeys) && raw.confirmedKeys.includes(k) && values[k]), savedAt: raw.savedAt };
  }
  let stored = null;
  try { stored = localStorage.getItem(key); }
  catch (_) { try { stored = sessionStorage.getItem(key); } catch (_) { /* URL fallback still works. */ } }
  let current = null;
  try { current = valid(JSON.parse(stored)); } catch (_) { /* Ignore malformed storage. */ }
  const clone = value => value ? JSON.parse(JSON.stringify(value)) : null;
  const savedState = record => JSON.stringify(record || { version: 1, values: {}, confirmedKeys: [], savedAt: Date.now() });
  function syncSession() {
    try {
      sessionStorage.setItem(key, savedState(current));
      if (current) sessionStorage.setItem('jsdf-vehicle-v2', JSON.stringify(current.values));
      else sessionStorage.removeItem('jsdf-vehicle-v2');
    } catch (_) { /* Storage may be disabled. */ }
  }
  function syncURL() {
    const url = new URL(location.href);
    if (!core.keys.some(k => url.searchParams.has(core.params[k])) && !document.querySelector('js-diesel-results')) return;
    for (const k of core.keys) {
      url.searchParams.delete(core.params[k]);
      if (current?.values[k]) url.searchParams.set(core.params[k], current.values[k]);
    }
    url.searchParams.delete('jsdf_confirmed');
    if (current && core.vehicleKeys.every(k => current.confirmedKeys.includes(k))) url.searchParams.set('jsdf_confirmed', '1');
    try { history.replaceState(history.state, '', url.href); } catch (_) { /* The saved vehicle still works. */ }
  }
  function emit() {
    syncSession();
    syncURL();
    window.dispatchEvent(new CustomEvent('jss:vehicle-change', { detail: clone(current) }));
  }
  function set(values, confirmedKeys = []) {
    const record = valid({ version: 1, values, confirmedKeys, savedAt: Date.now() });
    current = record;
    // Keep an empty saved state on reset so old history URLs cannot restore it.
    try { localStorage.setItem(key, savedState(record)); } catch (_) { /* Storage may be disabled. */ }
    emit();
    return clone(record);
  }
  function fromURL(url) {
    const has = core.keys.some(k => url.searchParams.has(core.params[k]));
    if (!has) return null;
    // Multi-select filter URLs are not a single customer's vehicle.
    const values = Object.fromEntries(core.keys.map(k => [k, url.searchParams.getAll(core.params[k]).length === 1 ? url.searchParams.get(core.params[k]) : '']));
    const confirmedKeys = url.searchParams.get('jsdf_confirmed') === '1' ? core.vehicleKeys : (current && equal(values, current.values) ? current.confirmedKeys : []);
    return values.make ? { values: clean(values), confirmedKeys } : null;
  }
  function withVehicle(url, record = current) {
    const next = new URL(url, location.href);
    if (next.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(next.pathname)) return next;
    for (const k of core.keys) next.searchParams.delete(core.params[k]);
    next.searchParams.delete('jsdf_confirmed');
    if (record) {
      for (const k of core.keys) if (record.values[k]) next.searchParams.set(core.params[k], record.values[k]);
      if (core.vehicleKeys.every(k => record.confirmedKeys.includes(k))) next.searchParams.set('jsdf_confirmed', '1');
    }
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && !next.searchParams.has('preview_theme_id')) next.searchParams.set('preview_theme_id', preview);
    return next;
  }
  const explicit = fromURL(new URL(location.href));
  // A saved choice (including an explicit reset) wins over older page URLs.
  // Fresh visitors can still arrive through a shared vehicle-finder link.
  if (stored === null && explicit) set(explicit.values, explicit.confirmedKeys);
  else { syncSession(); syncURL(); }
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { current = valid(JSON.parse(event.newValue)); } catch (_) { current = null; }
    emit();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    try { current = valid(JSON.parse(localStorage.getItem(key))); emit(); }
    catch (_) { /* Retain the current selection when storage is blocked. */ }
  });
  // Carry selection through reviewed finder cards even when storage is blocked.
  // General search and other catalogues, including Holley, keep their original URLs.
  function decorate(event) {
    const link = event.target.closest?.('a[href]');
    if (!link || link.getAttribute('href')?.trim().startsWith('#')) return;
    if (!link.closest('.jsdf-native-card')) return;
    try { link.href = withVehicle(link.href).href; } catch (_) { /* Ignore non-URL actions. */ }
  }
  document.addEventListener('click', decorate, true);
  document.addEventListener('auxclick', decorate, true);
  document.addEventListener('pointerdown', decorate, true);
  document.addEventListener('contextmenu', decorate, true);
  window.JSSVehicle = { get: () => clone(current), set, clear: () => set({}), clean, equal, withVehicle, key };
})();
